import { motion } from 'framer-motion';

import { WHY_IT_WORKS_CARDS } from './whyItWorksData';
import WhyItWorksCard from './whyItWorksCard';

const fadeUpVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0 },
};

const WhyItWorks = () => {
  return (
    <div className="flex flex-col items-center bg-[#181B43] sm:py-20 sm:px-[120px] py-10 px-5 gap-10">
      <div className="flex flex-col items-center gap-1 w-full max-w-[1200px]">
        <motion.div
          className="w-full whitespace-nowrap text-[24px] leading-[30px] sm:text-[40px] sm:leading-[52px] tracking-[0.02em] sm:tracking-[0.04em] text-center text-[#F8FAFC] font-gilroy-bold"
          variants={fadeUpVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5, delay: 0, ease: 'easeOut' }}
        >
          Why Renaissance Plus Works
        </motion.div>
        <motion.div
          className="w-full text-[14px] leading-[18px] sm:text-[16px] sm:leading-[22px] tracking-[0.02em] text-center text-[#F8FAFC] font-[Gilroy-Regular]"
          variants={fadeUpVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.5, delay: 0.5, ease: 'easeOut' }}
        >
          A complete learning system to help you master software engineering, build with AI and prepare for high-growth technical roles.
        </motion.div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full max-w-[1200px]">
        {WHY_IT_WORKS_CARDS.map((card, index) => (
          <WhyItWorksCard key={card.title} {...card} index={index} />
        ))}
      </div>
    </div>
  );
};

export default WhyItWorks;
